<template>
  <div>
    <h1 class="item-title">{{ $t('components_invoice_deposit_refund.sqtyjxx') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_invoice_deposit_refund.shen_qing_ren') }}:</span>
          <span class="value">{{detail.creator}}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_invoice_deposit_refund.shen_qing_shi_jian') }}:</span>
          <span class="value">{{$momentLocal(detail.gmtCreate || detail.paymentConfirmTime)}}</span>
        </el-col>
        <!-- <el-col :span="8">
          <span class="label">{{ $t('pid_refund_sqrssgs') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col> -->
        <el-col :span="8">
          <span class="label">{{ $t('components_invoice_deposit_refund.sqtkfs') }}:</span>
          <span class="value">{{ getDicValue('refund_method', detail.refundMethod) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_invoice_deposit_refund.sqtkms') }}:</span>
          <span class="value">{{ detail.refundDesc }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_invoice_deposit_refund.ytkyjmx') }}</h1>
    <div style="margin-bottom: 30px">
      <custom-table ref="customTb1" tableCode="deposit_refund" :data="billList" @filter="filterChange" @sort="sortChange" :filterArr="['action', 'receivableOrgName']"></custom-table>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '' // 新增时为orderId, 编辑查看时为changeId
        };
      }
    }
  },
  data() {
    return {
      detail: {},
      billList: [],
    };
  },
  mounted() {
    this.getChangeDetail();
  },
  methods: {
    // 获取变更详情
    getChangeDetail: function () {
      this.$getJSON(apis.DepositRefundApplyDetail, {
        changeId: this.model.changeId
      }).then((res) => {
        this.billList = res.data.billList;
        this.detail = res.data;
      });
    },
    onConfirm() {
      if (this.model.type === 'watch') {
        this.$emit('close');
      }
    }
  }
};
</script>

<style lang="scss"></style>
